import {
    ClientsCloseOverviewView,
    ClientsCloseOverviewViewSchema,
} from "@common/types/views/clientsCloseOverviewView";
import { useDefaultClientsClosesView } from "@components/organizationView/clients-closes/views/DefaultClientsClosesView";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

interface UseClientsCloseOverviewViewStoreOptions {
    cacheKey?: ORGANIZATION_USER_CACHE_KEYS;
}

export function useClientsCloseOverviewViewStore({
    cacheKey,
}: UseClientsCloseOverviewViewStoreOptions = {}) {
    const defaultView = useDefaultClientsClosesView();

    return useViewStore<ClientsCloseOverviewView>({
        defaultView,
        viewSchema: ClientsCloseOverviewViewSchema,
        cacheKey,
    });
}
